<template>
  <div class="audio">
    <!-- <audio id="audio_bar" class="audio_bar">お使いのデバイスでは音声を再生することができません</audio> -->
    <div id="js-audio-wrap" class="audio_wrap">
      <div @click="toggleChapter('prev')" class="prev"><img :src="require('@/assets/images/fanclub/notes/prev.svg')" alt=""></div>
      <div @click="toggleAudio()" class="audio_controls play"><img :src="require('@/assets/images/fanclub/notes/play.svg')" alt=""></div>
      <div @click="toggleChapter('next')" class="next"><img :src="require('@/assets/images/fanclub/notes/next.svg')" alt=""></div>
      <button @click="mute()" type="button" class="sound">
        <SoundPlay v-if="!isMuted" />
        <SoundMute v-else />
      </button>
    </div>
    <div class="audio_time">
      <div :style="{ left: barLeftStyle + '%' }" class="time_start"></div>
      <div :style="{ '--audio-progress-percent': audioStyle.progress + '%' }" class="time_bar"></div>
      <p class="time_now rr">{{ calcTime(isAudio.currentTime) }}</p>
      <p class="time_total rr">{{ calcTime(isAudio.duration) }}</p>
    </div>
  </div>
</template>

<script>
import Config from '@/config/config';
import SoundPlay from '@/components/fanClub/notes/svg/SoundPlay';
import SoundMute from '@/components/fanClub/notes/svg/SoundMute';

export default {
  components: {
    SoundPlay,
    SoundMute
  },
  data() {
    return {
      isAudioPlay: false,
      isAudio: {
        duration: 0,
        currentTime: 0,
      },
      barLeftStyle: 0,
      audioStyle: {
        progress: 0,
      },
      isMuted: false, // falseは音が出る
    }
  },
  methods: {
    audioInit() {
      const Audio = document.getElementById('audio_bar');
      if(Audio != null) {
        Audio.remove()
      }
      this.isAudioPlay = false;
      this.isAudio.duration = 0;
      this.isAudio.currentTime = 0;
      this.barLeftStyle = 0;
      this.audioStyle.progress = 0;
      this.isAudioPlay = false;
    },
    toggleChapter(toggle) {
      this.$emit('changeChapter', toggle);
    },
    calcTime(sec) {
      // let hour = Math.floor(sec / 3600);
      let min = Math.floor(sec % 3600 / 60);
      let rem = Math.floor(sec % 60);
      return `${min}:${rem}`;
    },
    setAudio(audioPath) {
      this.audioInit();
      let newAudio = document.createElement('audio');
      newAudio.setAttribute('id', 'audio_bar');
      newAudio.className = 'audio_bar';
      newAudio.src = Config.APIURL + audioPath;

      let audioNextDOM = document.getElementById('js-audio-wrap');
      audioNextDOM.before(newAudio);

      const Audio = document.getElementById('audio_bar');

      //
      // Audio.src = Config.APIURL + audioPath;

      Audio.addEventListener('canplay', () => {
        this.isAudio.duration = Audio.duration;
      });
      Audio.addEventListener('timeupdate', () => {
        this.isAudio.currentTime = Audio.currentTime;
      });
      Audio.addEventListener('ended', () => {
        console.log('終');
        this.audioInit();
        this.endChapter();
      });
      // let index = AudioData.note.chapterList.findIndex(val => val.seqNo == this.nowSeqNo);
      return Audio;
    },
    endChapter() {
      this.$emit('endChapter');
    },
    playAudioFromNotes() {
      const Audio = document.getElementById('audio_bar');
      Audio.play();
      this.isAudioPlay = true;
    },
    toggleAudio() {
      const Audio = document.getElementById('audio_bar');
      if(this.isAudioPlay) {
        Audio.pause();
        this.isAudioPlay = false;
      } else {
        // Audio.src = Config.APIURL + this.note.everyDayNote.note.chapterList[0].audioPath;
        Audio.play();
        this.isAudioPlay = true;
      }

    },
    mute() {
      const Audio = document.getElementById('audio_bar');
      if(Audio.muted) {
        this.isMuted = false;
      } else {
        this.isMuted = true;
      }

      Audio.muted = this.isMuted;

    },
  },
  watch: {
    isAudio: {
      deep: true,
      handler() {
        let percent = this.isAudio.currentTime / this.isAudio.duration * 100;
        this.barLeftStyle = percent;
        this.audioStyle.progress = percent;
      },
    }
  }
}
</script>

<style lang="css" scoped>
.audio_wrap {
  -ms-align-items: center;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 25px;
  position: relative;
}
.audio .prev,
.audio .next {
  max-width: 27px;
  width: 20%;
}
.audio .play {
  margin: auto 13%;
  max-width: 60px;
  width: 20%;
}

.audio .sound {
  align-items: center;
  background: transparent;
  border: none;
  bottom: 0;
  display: flex;
  margin: auto;
  position: absolute;
  padding: 0;
  right: 0;
  top: 0;
}

.audio_time {
  margin-top: 28px;
  position: relative;
  padding-bottom: 26px;
}

.audio_time .time_bar {
  border-radius: 30px;
  height: 4px;
  position: relative;
  width: 100%;
}
.audio_time .time_bar::before {
  background-color: #464F59;
  bottom: 0;
  border-radius: 30px;
  content: '';
  height: 4px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.audio_time .time_bar::after {
  background-color: #449AFF;
  bottom: 0;
  border-radius: 30px;
  content: '';
  height: 4px;
  left: 0;
  position: absolute;
  width: var(--audio-progress-percent);
  z-index: 2;
}

.audio_time .time_now,
.audio_time .time_total {
  bottom: 0;
  color: #fff;
  font-size: 12px;
  position: absolute;
}
.audio_time .time_now {
  left: 0;
}
.audio_time .time_total {
  right: 0;
}

.audio_time .time_start {
  background-color: #449AFF;
  border-radius: 50%;
  height: 12px;
  /* left: 0; */
  position: absolute;
  top: -4px;
  width: 12px;
  z-index: 3;
}

</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/AudioPlayer.vue